import { render } from "./SubirImagenesComponent.vue?vue&type=template&id=d5b25454&scoped=true"
import script from "./SubirImagenesComponent.vue?vue&type=script&lang=js"
export * from "./SubirImagenesComponent.vue?vue&type=script&lang=js"

import "./SubirImagenesComponent.vue?vue&type=style&index=0&id=d5b25454&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5b25454"]])

export default __exports__